import 'ui-core/widgets/disable-adblocker/js/disable-adblocker.js';

UX.disableAdblocker.hasAdBlock = function () {
    const t = document.createElement('div');
    (t.innerHTML = '&nbsp;'),
        (t.className =
            'adsbox ads advertisement ad-hero pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads adglare-ad-server text-ad-links');
    let e = !(t.style =
        'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;');
    try {
        document.body.appendChild(t);
        const a = document.querySelector('.adsbox');
        if (((0 !== a.offsetHeight && 0 !== a.clientHeight) || (e = !0), void 0 !== window.getComputedStyle)) {
            const d = window.getComputedStyle(a, null);
            !d ||
                ('none' !== d.getPropertyValue('display') && 'hidden' !== d.getPropertyValue('visibility')) ||
                (e = !0);
        }
        document.body.removeChild(t);
    } catch (a) {
        console.error(a);
    }
    return e;
};
